import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MUIAlertDialog = ({
  open,
  onClose,
  message,
  okClickHandler,
  title = 'Alert',
  okText = 'OK',
  showCloseIcon = true,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle variant='h3' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        {showCloseIcon && (
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        <Typography variant="h4">{message}</Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={okClickHandler}>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MUIAlertDialog